import API from "../services/apiservices";

async function getid() {
  await API.getLocalDBDocument("caixasaidaStore").then((doc) => {
    if (doc && doc.data.Success) {
      return doc.data.Data[0].id;
    } else {
      return 0;
     }
  });
}


export default {
  namespaced: true,
  namespace: "caixasaidaStore",

  state: {
    storename: "caixasaidaStore",
    caixasaida: {
      api: null,
      data: [],
      id: 0,
      error: ""
    },
    emptycaixasaida: {
      api: null,
      data: [],
      id: 0,
      error: ""
    }
  },

  getters: {
    gtxStore: () => ({name: "caixasaidaStore", route: "Servicos/Caixasaida/Get", setter: "setCaixasaida"}),
    gtxCaixasaida: (state) => state.caixasaida,
    gtxCaixasaida_data: (state) => state.caixasaida.data || [],
    gtxCaixasaida_GetById: (state) => (id) => state.caixasaida.data.find(f => f.id == id) || {value: 0, text: ""},
    gtxCaixasaida_selected: (state, getters) => state.caixasaida.data.find(f => f.id == getters.gtxCaixasaida_id),
    gtxCaixasaida_id: (state) => state.caixasaida.id,
    gtxCaixasaida_dataoptions: (state) => (marca = 1) => ((state.caixasaida.data.filter(f=>f.Marca === marca) || []).map(o=>({value: o.id, text: o.Nome}))) || [],
    gtxCaixasaida_nome: (state, getters) => {
      const data = state.caixasaida.data.find(f => f.id == getters.gtxCaixasaida_id);
      return data ? data.Nome : "";
    },
    gtxcaixasaida_error: (state) => state.caixasaida.error,
  },

  mutations: {
    setCaixasaida: (state, caixasaida) => {
      state.caixasaida = caixasaida ? caixasaida : state.emptycaixasaida
    },
    setCaixasaidaid: (state, id) => (state.caixasaida.id = id),
    setCaixasaidadata: (state, data) => (state.caixasaida.data = data),
    setCaixasaidaerror: (state, error) => (state.caixasaida.error = error),
  },

  actions: {
    actCaixasaidaGet({ commit, getters, rootGetters }, notify = true) {
      
      // tem que definir um getter com os dados da store conforme o exemplo:
      // gtxStore: () => ({name: "caixasaidaStore", route: "Servicos/caixasaida/Get", setter: "setcaixasaida"}),

      // verifica a última atualização da store ...
      return new Promise((res, rej) => {
        try {
          // if (notify) console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
          API.get("Servicos/Stores/Get", { StoreName: getters.gtxStore.name }, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
              if (localUpdate > storeUpdate) {
                commit(getters.gtxStore.setter, doc.data);
                res(doc.data);
              } else {
                API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                  const data = API.prepareData(apidata.data);
                  commit(getters.gtxStore.setter, data);
                  API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                  res(data);
                });
              }
            });
          // }
        });
        } catch (err) {
          rej(err);
        }
      });
    },
    actCaixasaidaDel({ commit }, caixasaida) {
      commit('setCaixasaida', caixasaida);
    },
    actCaixasaidaErrorClear({ commit }) {
      commit('setCaixasaidaerror', '');
    },
    actCaixasaidaUpdate({ dispatch, commit }, caixasaida) {
      return new Promise((resolve) => {
        // console.log('caixasaida.actCaixasaidaUpdate:', caixasaida);
        API.post("Servicos/Caixasaida/Set", caixasaida, false)
          .then((apidata) => {
            const data = API.prepareData(apidata.data);
            // console.log('caixasaida.actCaixasaidaUpdate.data:', data);
            if (data.success) {
              dispatch("actCaixasaidaGet");
              resolve(data);
            } else {
              commit("setCaixasaidaerror", data.error);
              resolve(data);
            }
          });
      })
    },
    actCaixasaidaMudaCodigo({ commit, getters }, id) {
      const data = getters.gtxCaixasaida_data.find(f => f.id == id);
      if (data) {
        commit("setcaixasaidaid", data.id);
      }
    }
  },
};
